import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import PresetContainer from "../../components/PresetContainer";
import {
  ViewContainer,
  ContentSection,
  SectionTitle,
  SectionContent,
} from "./styles";
import { useFetchDocument } from "../../hooks/useFetchDocument";
import Loading from "../../components/Loading";

const enviroment = process.env.REACT_APP_ENVIROMENT;

const AdminConfig = () => {
  const navigate = useNavigate();

  const { document, loading, error } = useFetchDocument(
    enviroment === "prod" ? "config" : "config-test",
    "config",
  );

  return (
    <PresetContainer>
      {loading && (
        <>
          <Loading />
        </>
      )}
      {document && !loading && !error && (
        <ViewContainer>
          <ContentSection>
            <SectionTitle>Sobre a Misenscene:</SectionTitle>
            <SectionContent>{document && document.sobre_nos}</SectionContent>
          </ContentSection>
          <ContentSection>
            <SectionTitle>Cidades:</SectionTitle>
            {document &&
              document.cidades &&
              document.cidades.map((cidade, index) => (
                <SectionContent key={index}>
                  {cidade.cidade} ({cidade.ativo ? "Ativo" : "Inativo"})
                </SectionContent>
              ))}
          </ContentSection>
          <ContentSection
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Button
              type="primary"
              title="Editar"
              handleClick={() => navigate("/admin-edit-config")}
            />
          </ContentSection>
        </ViewContainer>
      )}
    </PresetContainer>
  );
};

export default AdminConfig;
